import { inject } from '@angular/core';

import {
	DeviceClaimingApiService,
	InventoryDevicesApiService,
	ScheduledJobsApiService,
	SystemStatusApiService
} from '../api';
import { InventoryDataAggregationService } from '../services/inventory-data-aggregation.service';

/**
 * Common location to inject and initialize all CDM data access services that should be initialized
 * as soon as the app, user, and feature flags have loaded, regardless of route.
 */
export function cdmDataAccessInitGuard(): boolean {
	inject(DeviceClaimingApiService);
	inject(InventoryDevicesApiService);
	inject(ScheduledJobsApiService);
	inject(SystemStatusApiService);
	inject(InventoryDataAggregationService);
	return true;
}
